<template>
  <div class="modal_wrap system mobile_notice_modal" :class="{ on: show }">
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">선택약정, 공시지원은 무엇인가요?</h1>
        </div>
        <div class="modal_con">
          <div class="modal_txt">
            <ul>
              <li>
                <div class="txt_1">공시지원금</div>
                <div class="txt_2">단말기 비용을 할인해주는 제도</div>
              </li>
              <li>
                <div class="txt_1">선택약정</div>
                <div class="txt_2">요금을 할인해 주는 제도</div>
              </li>
              <li>
                <div class="txt_3">
                  할인 폭 및 부가조건을 꼼꼼히 살펴보고<br />
                  내게 맞는 제도(할인)를 선택하세요!
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="close()">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StorageFactory from '@common/lib/common/storage';

export default {
  props: {
    show: Boolean,
    data: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
